import React from "react";
import * as PropTypes from "prop-types";
import styled from "styled-components";
import { Typography } from "@material-ui/core";
import BadgeSupplier from "./BadgeSupplier";
import { greaterOrEqualThan } from "../../util/mediaQuery";

const GridFlexboxColumn = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
  text-align: center;
  width: 10rem;
  ${greaterOrEqualThan.xs`width: 7rem;`};
  padding: 0 0.2rem;
`;

const BadgeItem = ({ caption, outline }) => (
  <GridFlexboxColumn>
    <BadgeSupplier caption={caption} outline={outline} />
    <Typography variant="body1">{caption}</Typography>
  </GridFlexboxColumn>
);

BadgeItem.defaultProps = {
  outline: "silver",
};
BadgeItem.propTypes = {
  caption: PropTypes.string.isRequired,
  outline: PropTypes.string,
};

export default BadgeItem;